import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultCosts,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const propertyOwnerHouseRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: validationRules.price,
    plotArea: validationRules.plotArea,
  },
  otherFacilities: {
    totalFloorsNumber: validationRules.totalFloors,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    usableArea: validationRules.usableArea,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  costs: {
    ...defaultCosts,
    heatingCosts: validationRules.heatingCosts,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  tenantDocuments: { solvency: [], rental: [], income: [], selfReport: [], identification: [] },
}
